<template>
    <el-dialog v-loading="loading" title="创建联系人" :visible.sync="dialogVisible" width="40%" top="10px">
        <el-form :rules="rules" ref="dataForm" :model="new_contact" label-position="right" label-width="160px">
          <el-row>
            <el-col :span="12">
              <!-- 姓名 -->
              <el-form-item label="姓名" prop="name">
                <el-input v-model="new_contact.name" placeholder="请输入姓名"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="性别" prop="gender">
                <el-radio-group v-model="new_contact.gender">
                  <el-radio v-for="gender in gender_list" :key="gender.code" :label="gender.code">{{ gender.value }}
                  </el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <!-- 手机号 -->
              <el-form-item label="手机号" prop="mobile">
                <el-input v-model="new_contact.mobile" maxlength="11" placeholder="请输入手机号"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <!-- 固话-->
              <el-form-item label="固定电话" prop="phone">
                <el-input v-model="new_contact.phone" placeholder="请输入固定电话"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="12">
              <!-- 邮箱 -->
              <el-form-item label="邮箱" prop="email">
                <el-input v-model="new_contact.email" placeholder="请输入邮箱"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <!-- 微信 -->
              <el-form-item label="微信" prop="wechat">
                <el-input v-model="new_contact.wechat" maxlength="11" placeholder="请输入微信号"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <!-- 地址-->
              <el-form-item label="地址" prop="address">
                <el-input v-model="new_contact.address" placeholder="请输入地址"></el-input>
              </el-form-item>
            </el-col>
            <!-- 管理人-->
            <el-col :span="12">
              <el-form-item label="管理人" prop="owner">
                <el-select v-model="new_contact.owner" filterable placeholder="请选择管理人" class="w-100">
                  <el-option
                    v-for="(user, index) in user_list"
                    :key="index"
                    :label="user.first_name"
                    :value="user.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

        <!-- 享有人信息 ------------------------------------------------------------------------------ -->
          <el-row class="el-row-divider">
            <el-col :span="22" >
              <el-divider content-position="left"><span class="title">享有人信息</span></el-divider>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="联系人享有人" prop="assistants">
                <el-select class="w-100" v-model="new_contact.assistants" filterable multiple
                          placeholder="请选择联系人享有人">
                  <el-option v-for="user in user_list" :key="user.id" :label="user.first_name"
                            :value="user.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="24" class="border-top mt-2 pt-3">
              <el-form-item>
                <el-button size="small" @click="cancelData">取消</el-button>
                <template v-if="$perm(['contact.add_contact'])">
                  <el-button size="small" type="primary" @click="createData()">创建并绑定</el-button>
                </template>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
    </el-dialog>
  </template>
  <script>
    import {isValidMobileNumber} from '@/utils/validate'
    import {createContact} from '@/api/contact'
    import {fetchDictList, fetchUserList} from '@/api/common'
  
    export default {
      name: "contact-dialog",
      data() {
        var contactFillingStatus = () => {
          let mobile = ''
          if (this.new_contact.mobile !== undefined && this.new_contact.mobile !== null && this.new_contact.mobile !== ''){
            mobile = this.new_contact.mobile.trim()
          }
          let phone = ''
          if (this.new_contact.phone !== undefined && this.new_contact.phone !== null && this.new_contact.phone !== ''){
            phone = this.new_contact.phone.trim()
          }
  
          if (mobile === '' && phone === ''){
            // 没有填写客户手机, 也没填写联系人
            return 'ALL_BLANK' 
          } else if (mobile !== '') {
            // 填写了客户手机号
            return 'FILLED_MOBILE'
          } else {
            return 0
          }
        };
  
        var checkMobile = (rule, value, callback) => {
          let status = contactFillingStatus()
          switch(status) {
            case 'ALL_BLANK': 
              return callback(new Error('联系人手机号或固话需要至少填写一项'));
              break;
            case 'FILLED_MOBILE':
              if (!isValidMobileNumber(value)) {
                return callback(new Error('手机格式不正确'))
              }
              return callback();
              break;
            default:
              return callback()
          }
        };
  
        var checkContactName = (rule, value, callback) => {
          var reg = new RegExp("[`~!@#$^&*=|{}':;',\\[\\].<>/?~！@#￥……&*——|{}【】‘；：”“'。，、？]", "g")
  
          if (value == undefined || value == null || value == "") {
            return callback(new Error("请输入客户名称"))
          }
          else if (value.length > 4) {
            return callback(new Error("个人名称不得超过4个字"))
          }
          else if (reg.test(value)) {
            return callback(new Error("名称不能含有特殊字符"))
          }
          else {
            return callback()
          }
        };
  
        return {
          dialogVisible: false,
          rules: {
            name: [{required: true, trigger: 'blur', validator: checkContactName}],
            mobile: [{validator: checkMobile, trigger: 'blur'}],
            owner: [{required: true, message: '请选择管理人', trigger: 'blur'}],
          },
          loading: false,
          loadingText: '正在加载数据，请销等...',
          new_customer:{},
          new_contact: {
            name: '',
            gender: null,
            mobile: '',
            phone: '',
            email: '',
            wechat: '',
            address: '',
            owner: null,
            assistants: [],
          },
          gender_list: [],
          user_list: [],
        }
      },
      computed: {
        isOwn: function () {
          return (
            !this.new_contact.owner ||
            this.$store.state.user.user === this.new_contact.owner
          );
        },
      },
      methods: {
        loadData() {
          let p1 = fetchDictList({type: 'contact.gender'})
          let p2 = fetchUserList()

          this.loading = true
          Promise.all([p1, p2])
            .then(res => {
              this.gender_list = res[0]
              this.user_list = res[1]
              this.loading = false
            })
            .catch(error => {
              this.loading = false
              this.$message.error(error)
            })
        },
        reset_new_contact() {
          this.new_contact = {}
        },
        handleOpen(new_customer) {
          this.new_customer = new_customer
          this.dialogVisible = true
        },
        cancelData() {
          this.$refs.dataForm.resetFields()
          this.reset_new_contact()
          this.dialogVisible = false
        },
        createData(type) {
          let create_name = this.new_contact.name
          this.$refs['dataForm'].validate(valid => {
            if (valid) {
              this.loading = true
              this.loadingText = '正在保存联系人数据，请稍等...'
              createContact(this.new_contact)
                .then(res => {
                  this.loading = false
                  this.$message.success('保存联系人信息成功')
                  this.$nextTick(() => {
                    this.$refs.dataForm.clearValidate()
                    this.$refs.dataForm.resetFields()
                    this.reset_new_contact()
                    if (this.new_customer.name === create_name && this.new_customer.type === '1'){
                      res['permission'] =  ["receive_file", "participate_activity", "sign_document", "payment"]
                    }
                    else{
                      res['permission'] = []
                    }  
                    this.$emit("updateContactList", res)
                    this.dialogVisible = false
                  })
                })
                .catch(error => {
                  this.loading = false
                  this.$message.error(error)
                })
            }
          })
        },
      },
      created() {
        this.loadData()
      }
    }
  </script>
  
  <style scoped>
  .el-row-divider {
    margin-top: 36px
  }
  
  .title {
    font-weight: bold;
  }
  
  .highlight {
    color:red;
  }
  
  </style>      